export const frequencyMapping = {
  1: 'Weekly',
  2: 'Fortnightly',
  4: 'Monthly'
}
